import { Check } from "lucide-react";

export default function Crypto() {
  const benefits = [
    {
      title: "YouTube earnings to crypto",
      description:
        "Set it up once and receive your earnings in crypto automatically",
    },
    {
      title: "Automatic conversion",
      description:
        "Convert your payments directly to BTC, ETH, USDT, and other popular cryptocurrencies",
    },
    {
      title: "Transparent fees",
      description: "Competitive rates for converting or withdrawing crypto",
    },
  ];

  return (
    <div className="bg-white py-20 lg:py-32 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left Column - Image */}
          <div className="w-full lg:w-[389px] flex-shrink-0 order-2 lg:order-1">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/pay-4card.png"
              alt="Withdrawal Methods"
              className="w-full h-auto"
            />
          </div>

          {/* Right Column - Content */}
          <div className="flex flex-col gap-[27px] items-start w-full lg:w-[728px] order-1 lg:order-2">
            {/* Badge */}
            <div
              className="flex items-center justify-center rounded-[100px] w-[77px] h-[50px] text-white text-[32px] font-semibold"
              style={{
                backgroundImage:
                  "linear-gradient(149.456deg, rgb(0, 166, 86) 2.173%, rgb(9, 145, 41) 52.175%, rgb(18, 126, 0) 97.827%)",
              }}
            >
              04
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl xxs:text-5xl xs:text-6xl sm:text-6xl md:text-6xl lg:text-[80px] 4xl:text-[80px] font-normal text-black leading-[106px] xxs:leading-tight xs:leading-tight sm:leading-tight md:leading-tight lg:leading-normal enfinity-header-font">
              <span>Get your earnings </span>
              <span className="text-[#00A656]">paid in crypto</span>
            </h1>

            {/* Description */}
            <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black leading-[34px] max-w-[728px] enfinity-subtext-font">
              Convert your YouTube earnings directly into cryptocurrency.
              Receive payments in Bitcoin, Ethereum, USDT, or other popular
              cryptos, all within EnfiniPay.
            </p>

            {/* Benefits List */}
            <div className="flex flex-col gap-[30px] w-full max-w-[680px]">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex gap-[15px] items-start">
                  {/* Check Icon */}
                  <div className="bg-[#00A656] flex items-center justify-center rounded-[10px] w-[32px] h-[32px] shrink-0">
                    <Check className="w-5 h-5 text-white" strokeWidth={2} />
                  </div>

                  {/* Content */}
                  <div className="flex flex-col gap-[10px] flex-1">
                    <h3 className="text-[24px] font-medium text-black leading-[35px] enfinity-header-font">
                      {benefit.title}
                    </h3>
                    <p className="text-[18px] xxs:text-[1rem] lg:text-lg 4xl:text-[19px] font-normal text-black leading-normal enfinity-subtext-font">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
